/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of AutomatedTasksClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfList_1OfAutomatedTask,
  SuccessResponse_1OfAutomatedTaskDetails,
  SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate,
  AutomatedTask,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockAutomatedTasks: AutomatedTask[] = [
  {
    id: 1,
    name: 'Daily Stock Count Reminder',
    userId: 1,
    isActive: true,
    emailUser: true,
    additionalEmails: 'team@example.com',
    saveToUserReports: true,
    taskType: 'StockCountReminder',
    taskData: '{}',
    schedules: [],
  },
  {
    id: 2,
    name: 'Weekly Report Generation',
    userId: 1,
    isActive: true,
    emailUser: true,
    additionalEmails: undefined,
    saveToUserReports: true,
    taskType: 'ReportGeneration',
    taskData: '{}',
    schedules: [],
  },
];

/* ---- Mocked Client Implementation ---- */

import { IAutomatedTasksClient } from '../../interfaces';
export class AutomatedTasksClientMocked implements IAutomatedTasksClient {
  constructor(baseUrl?: string) {}

  async automatedtaskGET(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfAutomatedTask> {
    await delay();
    const tasks = mockAutomatedTasks;
    return successResponse(tasks) as SuccessResponse_1OfList_1OfAutomatedTask;
  }

  async task(id: number, storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfAutomatedTaskDetails> {
    await delay();
    const task = mockAutomatedTasks.find((t) => t.id === id);
    return successResponse({
      ...task,
      createdBy: 'admin@example.com',
      createdDate: '2025-01-01',
      lastModifiedBy: 'admin@example.com',
      lastModifiedDate: '2025-01-01',
    }) as SuccessResponse_1OfAutomatedTaskDetails;
  }

  async automatedtaskDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockAutomatedTasks.findIndex((t) => t.id === id);
    if (index > -1) {
      mockAutomatedTasks.splice(index, 1);
    }
  }

  async automatedtaskPOST(body?: AutomatedTask, cancelToken?: CancelToken): Promise<void> {
    await delay();
    if (body) {
      mockAutomatedTasks.push({ ...body, id: mockAutomatedTasks.length + 1 });
    }
  }

  async previewdates(body?: AutomatedTask, cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate> {
    await delay();
    return successResponse([
      { date: '2025-12-15', dayOfWeek: 'Monday' },
      { date: '2025-12-22', dayOfWeek: 'Monday' },
      { date: '2025-12-29', dayOfWeek: 'Monday' },
    ]) as SuccessResponse_1OfList_1OfAutomatedTaskPreviewDate;
  }

  // ====== Auto-generated stub methods ======




}
